var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "override_settings" }, [
    _c(
      "div",
      [
        _c("yes_no", {
          key: "OVERRIDE_LOCATION_SETTINGS",
          attrs: { title: "OVERRIDE_LOCATION_SETTINGS" },
          on: {
            input: function ($event) {
              return _vm.on_change_value("can_override")
            },
          },
          model: {
            value: _vm.can_be_override,
            callback: function ($$v) {
              _vm.can_be_override = $$v
            },
            expression: "can_be_override",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.can_be_override
      ? _c(
          "div",
          { staticClass: "pos_settings p-2" },
          [
            _vm._l(_vm.basic_params, function (key_val, key_name) {
              return key_name.length > 0 && _vm.is_text_field(key_name)
                ? _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("info_field", {
                        attrs: {
                          f_uniq: key_name,
                          f_type: key_name,
                          f_title: _vm.__t(key_name.toUpperCase()),
                          is_disabled: false,
                          f_val: _vm.basic_params[key_name],
                        },
                        on: {
                          change: function ($event) {
                            return _vm.on_change_value(key_name)
                          },
                        },
                        model: {
                          value: _vm.basic_params[key_name],
                          callback: function ($$v) {
                            _vm.$set(_vm.basic_params, key_name, $$v)
                          },
                          expression: "basic_params[key_name]",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group row" },
              _vm._l(_vm.basic_params, function (key_val, key_name) {
                return key_name.length > 0 &&
                  !_vm.is_text_field(key_name) &&
                  key_name != "id"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-sm-4 col-md-4 col-xs-12 mb-3",
                      },
                      [
                        key_name == "percent_type"
                          ? _c("div", { staticClass: "form-group mt-2" }, [
                              _c("label", { staticClass: "form-label" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.__t("PERCENT_TYPE")) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "input-group flex-nowrap" },
                                [
                                  _c("b-form-radio-group", {
                                    attrs: {
                                      id: "btn-radios-1",
                                      "button-variant": "outline-primary",
                                      options: [
                                        {
                                          text: _vm.__t("PERCENT_LABEL"),
                                          value: "percent",
                                        },
                                        {
                                          text: _vm.__t("FIXED"),
                                          value: "fixed",
                                        },
                                      ],
                                      name: "radios-btn-default",
                                      buttons: "",
                                    },
                                    on: {
                                      update: function ($event) {
                                        return _vm.on_change_value(key_name)
                                      },
                                    },
                                    model: {
                                      value: _vm.basic_params[key_name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.basic_params,
                                          key_name,
                                          $$v
                                        )
                                      },
                                      expression: "basic_params[key_name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _c("yes_no", {
                              key: key_name,
                              attrs: { title: key_name },
                              on: {
                                input: function ($event) {
                                  return _vm.on_change_value(key_name)
                                },
                              },
                              model: {
                                value: _vm.basic_params[key_name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.basic_params, key_name, $$v)
                                },
                                expression: "basic_params[key_name]",
                              },
                            }),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "exclude_categories mt-4" },
      [
        _c("label", { staticClass: "form-label" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.__t("IGNORE_CATEGORIES_PERCENT_PRICE")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("v-select", {
          key: "id",
          staticClass: "imc_reasons",
          attrs: {
            multiple: "",
            label: "title",
            filterable: true,
            options: _vm.categories,
          },
          on: { search: _vm.onSearch, input: _vm.push_reason_str },
          model: {
            value: _vm.ignore_categories,
            callback: function ($$v) {
              _vm.ignore_categories = $$v
            },
            expression: "ignore_categories",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }